import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl-next';

import Tooltip from '@atlaskit/tooltip';

import { useGetExperimentValue } from '../../services/experiment-context';
import { EditionAwarenessLink } from '../edition-awareness-button';

interface PaymentFlowLinkProps {
	href: string;
}

/**
 * OSBEA experiment component
 * TODO: When productionising, clean up the existing <AddPaymentLink /> and consolidate.
 */
export const PaymentFlowLink = ({ href }: PaymentFlowLinkProps) => {
	const { getExperimentValue } = useGetExperimentValue();

	const handlePaymentFlowClick = useCallback(() => {
		// Fire exposure for ea_to_osb_experiment variant tenants
		getExperimentValue({
			statsigParams: {
				experimentName: 'ea_to_osb_experiment',
				parameterName: 'cohort',
				defaultValue: 'not-enrolled',
			},
			trackEventParameters: {
				trackEventGrowthInitiative: 'tako',
			},
		});
	}, [getExperimentValue]);

	return (
		<Tooltip
			content={
				<FormattedMessage
					id="@atlassian/edition-awareness.link.payment-flow-tooltip"
					defaultMessage="Add payment details to keep your subscription"
					description="Tooltip for add payment details button"
				/>
			}
			position="bottom"
		>
			<EditionAwarenessLink
				href={href}
				target="_blank"
				touchpointIntent="addPaymentDetails"
				linkId="payment-flow"
				onClick={handlePaymentFlowClick}
			/>
		</Tooltip>
	);
};
